import { TBusinessUser } from "@elixir/types";
import { getIdb } from "./bridges/methods";
import Fuse from "fuse.js";

export const businessUsersFuse = new Fuse([] as TBusinessUser[], {
  location: 0,
  threshold: 0.3,
  distance: 100,
  keys: ["fln"],
});

export default async function populateBusinessUsersFuse() {
  const idb = getIdb();
  const localBusinessUsers: TBusinessUser[] = await idb
    ?.table("businessUsers")
    ?.toArray();

  businessUsersFuse.setCollection(localBusinessUsers || []);
}
